var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-not_selected_task"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "not_selected_task",
    clipPath: "url(#clip-not_selected_task)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CheckmarkDavidSelected",
    transform: "translate(-38.992 -52.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(38.992 52.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 292,
    cy: 292,
    r: 292,
    transform: "translate(8 8)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 10
  })))))));
};
export default __webpack_public_path__ + "static/media/not_selected_task.f051205a.svg";
export { SvgComponent as ReactComponent };